import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ModalManager } from '@3plearning/react-components';
import { getClassrooms } from './course-assign-actions';
import StudentList from '../../components/student-list/student-list';
import Filter from '../../components/filters/filters';
import css from './course-assign.scss';
import Footer from '../../components/footer';
import Topics from '../../components/topics';
import { dismissModal } from '../../containers/modal-manager/modal-manager-actions';
import Toast from '../../components/toast';
import AssignLaterModal from '../../components/assign-later/assign-later';
import UnassignAllModal from '../../components/unassign-all-modal/unassign-all-modal';
import AssignmentsActionBar from '../../components/assignments-action-bar/assignments-action-bar';

const CourseAssign = ({ i18n }) => {
  const dispatch = useDispatch();
  const selectedProduct = useSelector((state) => state.product, shallowEqual);

  const modal = useSelector((state) => state.modalContainerReducer);

  useEffect(() => {
    dispatch(getClassrooms(selectedProduct.id));
  }, [dispatch, selectedProduct.id]);

  return (
    <>
      <div className={css['course-assign']}>
        <div className={css.component}>
          <div className={css.leftSection}>
            <Filter i18n={i18n} />
            <StudentList i18n={i18n} />
          </div>

          <Topics i18n={i18n} />
        </div>
        <AssignmentsActionBar>
          <Footer i18n={i18n} />
        </AssignmentsActionBar>
      </div>
      <Toast />
      <AssignLaterModal i18n={i18n} />
      <UnassignAllModal i18n={i18n} />
      <ModalManager
        modals={modal}
        onClose={() => {
          dispatch(dismissModal());
        }}
      />
    </>
  );
};

CourseAssign.propTypes = {
  i18n: PropTypes.object
};

export default CourseAssign;



// WEBPACK FOOTER //
// ./containers/course-assign/course-assign.js